import { useState } from "react";

const C = {
  pink: "#F7A1C4", mint: "#9ED9C3", yellow: "#FFD966",
  blue: "#9CCBFF", lilac: "#D7B7F6", ink: "#1F1F1F", cream: "#FFF8F1",
  pinkSoft: "#FDE8F0", mintSoft: "#E6F5EE", yellowSoft: "#FFF7DC",
  blueSoft: "#E4F0FF", lilacSoft: "#F0E5FC",
};
const heading = "'Baloo 2', cursive, sans-serif";
const body = "'Nunito', sans-serif";
const navMap = { "Home": "home", "Meet The Bunch": "meet", "Classes": "classes", "Gallery": "gallery", "Reviews": "reviews", "Parties": "parties", "Merch": "merch", "Schools": "schools", "Contact": "contact" };


const IMG = {
  logo: "/images/logo.webp",
  misty: "/images/characters/misty.webp",
};

const faqs = [
  { q: "What is The Funky Bunch and what makes it different?", a: "The Funky Bunch is a fun, inclusive dance class for walking to preschool-aged children. We focus on movement, music, confidence, and joy, not perfect steps. We believe every child belongs on the dancefloor. There is no pressure to perform, follow perfectly, or keep up. We celebrate all movement styles, abilities, and energy levels." },
  { q: "Is The Funky Bunch inclusive of additional needs?", a: "Yes, absolutely! The Funky Bunch is designed to be welcoming, flexible, and supportive. Children are encouraged to join in however they feel comfortable, whether that's big movements, small movements, or simply watching." },
  { q: "What ages are classes designed for?", a: "Our classes are designed for walking to preschool-aged children, typically from 1.5 to 5 years old. Although younger children are also welcome and can participate with their adult's help. Children can join at their own pace and take part in whatever way feels right for them. Adults must remain with their children throughout the duration of the class." },
  { q: "Do I need to book in advance?", a: "Yes, we recommend booking in advance to secure your child's place, as spaces are limited to keep classes calm and enjoyable. Bookings can be made through our website. Block bookings are at a discounted rate." },
  { q: "Will classes be on any other days?", a: "Classes will initially be on Thursdays but we hope to bring more classes very soon. Please do let us know which days you would like to see classes on!" },
  { q: "Does my child need dance experience to join in?", a: "Not at all! No experience is needed. Many children are dancing for the very first time, and that's exactly what The Funky Bunch is for. There won't be difficult steps to learn, or any expectations. It's all about having fun and building confidence!" },
  { q: "What happens in a typical class?", a: "Each class includes: a friendly warm-up song, fun movement and dance activity, music and imagination, time to dance freely and creatively, a mini disco, and a calm cool-down and goodbye." },
  { q: "Do parents/carers stay for the class?", a: "All parents/carers must stay for the entire session. Whether you choose to join in is your choice! Younger children often dance with their grown-up nearby, while older children may feel happy dancing independently. Both are welcome. Even babies on laps are welcome and often enjoy bopping to the music!" },
  { q: "What should my child wear?", a: "Comfortable clothes they can move in easily. Bare feet, socks, or shoes are all fine, whatever your child prefers. The Funky Bunch t-shirts will be available to purchase soon but are in no way mandatory. Please can adults ensure that no stilettos are worn to protect the floor in the studio." },
  { q: "What if my child is shy? Or has too much energy?", a: "That's completely okay. Children are never forced to participate. Watching, moving a little, or joining in later is all part of the experience. On the other hand, we love big jumps, wiggles, spins, and enthusiasm. High-energy and low-energy dancers are equally welcome." },
  { q: "What type of music do you use?", a: "We use fun, age-appropriate music with a mix of upbeat songs, including current pop songs and familiar rhythms that children love. No explicit versions are ever used." },
  { q: "When and where are classes held?", a: "Classes are held at Lumina Dance Company, Eden Business Centre, South Stour Ave, Ashford Kent TN23 7RS. Classes are term-time Thursdays from 10.30 to 11.15." },
  { q: "Is there car parking?", a: "Yes, there is space for 12 cars outside of the studio so please park considerately so we can fit as many cars in as possible. The road is permit only during the day. We are also walking distance from Ashford town centre and Ashford International train station." },
  { q: "Are there baby changing facilities?", a: "Absolutely. There are toilets in the studio with baby changing facilities." },
  { q: "Can I hire you for my child's birthday party?", a: "Absolutely! We offer three party packages (Bronze, Silver, Gold) for children up to age 8. Visit our Birthday Parties page for full details, or contact us through our website, social media or speak to us in class." },
];

const RainbowHeading = ({ children, size = 28, tag = "h2" }) => {
  const s = {
    fontFamily: heading, fontSize: size, fontWeight: 800, textAlign: "center",
    lineHeight: 1.3, margin: 0,
    background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac}, ${C.pink})`,
    backgroundSize: "200% 100%",
    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
    backgroundClip: "text", animation: "rainbowSlide 4s linear infinite",
  };
  if (tag === "h1") return <h1 style={s}>{children}</h1>;
  if (tag === "h3") return <h3 style={s}>{children}</h3>;
  return <h2 style={s}>{children}</h2>;
};

const Nav = () => {
  const links = ["Home", "Meet The Bunch", "Classes", "Gallery", "Reviews", "Parties", "Merch", "Schools", "Contact"];
  return (
    <nav style={{
      background: C.cream, padding: "10px 24px",
      position: "sticky", top: 0, zIndex: 100,
      borderBottom: `2px solid ${C.pink}15`,
      boxShadow: "0 2px 16px rgba(0,0,0,0.03)",
    }}>
      <div style={{
        maxWidth: 900, margin: "0 auto",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <img src={IMG.logo} alt="The Funky Bunch" style={{ height: 46, objectFit: "contain", cursor: "pointer" }} onClick={() => { window.location.hash = "home"; }} />
        <div style={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
          {links.map(l => (
            <span key={l} style={{
              fontSize: 11.5, fontFamily: body, fontWeight: 600,
              color: l === "Contact" ? C.pink : C.ink + "88",
              padding: "5px 9px", borderRadius: 14,
              background: l === "Contact" ? C.pinkSoft : "transparent",
              cursor: "pointer",
            }} onClick={() => { window.location.hash = navMap[l]; }}>{l}</span>
          ))}
          <span style={{
            background: C.pink, color: "#fff", padding: "7px 18px",
            borderRadius: 50, fontFamily: heading, fontWeight: 700, fontSize: 12,
            cursor: "pointer", marginLeft: 4,
          }} onClick={() => { window.location.hash = "classes"; }}>Book Now</span>
        </div>
      </div>
    </nav>
  );
};

const Footer = () => (
  <footer style={{ background: C.cream, padding: "36px 24px 20px", borderTop: `2px solid ${C.pink}15` }}>
    <div style={{ maxWidth: 900, margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 28, marginBottom: 24 }}>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Find Us</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>Lumina Dance Company<br />Eden Business Centre<br />South Stour Ave, Ashford<br />Kent TN23 7RS</div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Classes</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>Term-time Thursdays<br />10:30 – 11:15</div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Get in Touch</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>thefunkybunchashford@gmail.com</div>
          <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
            <a href="https://www.facebook.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.blue}><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg></a>
            <a href="https://www.instagram.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.pink}><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg></a>
          </div>
        </div>
      </div>
      <div style={{ height: 3, borderRadius: 2, marginBottom: 14, background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac})` }} />
      <div style={{ fontFamily: body, fontSize: 10, color: C.ink + "55", textAlign: "center" }}>© 2026 The Funky Bunch Kent. All rights reserved.</div>
    </div>
  </footer>
);

/* ═══ FAQ ACCORDION ═══ */
const FaqItem = ({ q, a, color, isOpen, onClick }) => (
  <div style={{
    background: "#fff", borderRadius: 16,
    border: `2px solid ${isOpen ? color + "44" : C.ink + "08"}`,
    marginBottom: 10, overflow: "hidden",
    transition: "border-color 0.3s ease",
  }}>
    <div
      onClick={onClick}
      style={{
        padding: "16px 20px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        cursor: "pointer", gap: 12,
      }}
    >
      <span style={{
        fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink,
        lineHeight: 1.4,
      }}>{q}</span>
      <div style={{
        width: 28, height: 28, borderRadius: "50%",
        background: isOpen ? color + "33" : C.ink + "08",
        display: "flex", alignItems: "center", justifyContent: "center",
        flexShrink: 0, transition: "all 0.3s ease",
      }}>
        <span style={{
          fontFamily: body, fontSize: 18, fontWeight: 700,
          color: isOpen ? color : C.ink + "55",
          transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
          transition: "transform 0.3s ease",
          display: "inline-block", lineHeight: 1,
        }}>+</span>
      </div>
    </div>
    {isOpen && (
      <div style={{
        padding: "0 20px 16px",
        fontFamily: body, fontSize: 13, color: C.ink + "aa",
        lineHeight: 1.7,
      }}>
        {a}
      </div>
    )}
  </div>
);

export default function ContactPage() {
  const [openFaq, setOpenFaq] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);

  const colors = [C.pink, C.yellow, C.mint, C.blue, C.lilac];

  const inputStyle = {
    width: "100%", padding: "11px 14px", borderRadius: 12,
    border: `1.5px solid ${C.lilac}30`, fontSize: 14,
    outline: "none", background: C.cream, fontFamily: body,
    marginBottom: 10,
  };

  return (
    <div style={{ background: C.cream, minHeight: "100vh" }}>
      <link href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;500;600;700;800&family=Nunito:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        @keyframes rainbowSlide {
          0% { background-position: 0% 50%; }
          100% { background-position: 200% 50%; }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
        button:hover { transform: scale(1.03); transition: transform 0.2s; }
        button:active { transform: scale(0.98); }
        input, textarea { font-family: 'Nunito', sans-serif; }
      `}</style>

      <Nav />

      {/* Hero */}
      <section style={{
        background: `linear-gradient(180deg, ${C.cream} 0%, ${C.lilacSoft} 100%)`,
        padding: "36px 24px 28px", textAlign: "center",
      }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={28} tag="h1">Get in Touch</RainbowHeading>
          <p style={{
            fontFamily: body, fontSize: 15, color: C.ink + "aa",
            lineHeight: 1.6, margin: "8px auto 0", maxWidth: 440,
          }}>
            Got a question? We'd love to hear from you.
          </p>
        </div>
      </section>

      {/* Contact + form */}
      <section style={{ padding: "32px 24px 40px" }}>
        <div style={{
          maxWidth: 900, margin: "0 auto",
          display: "flex", gap: 28, flexWrap: "wrap",
        }}>
          {/* Contact info */}
          <div style={{ flex: "1 1 280px" }}>
            <div style={{
              background: "#fff", borderRadius: 24,
              border: `2px solid ${C.lilac}20`,
              padding: "28px 24px", marginBottom: 20,
            }}>
              <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 16, color: C.ink, marginBottom: 16 }}>
                Contact details
              </div>
              <div style={{ fontFamily: body, fontSize: 14, color: C.ink + "99", lineHeight: 2.2 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill={C.pink}><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
                  <a href="mailto:thefunkybunchashford@gmail.com" style={{ color: C.ink, textDecoration: "none", fontWeight: 600 }}>thefunkybunchashford@gmail.com</a>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill={C.blue}><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                  <span style={{ fontWeight: 600 }}>The Funky Bunch Kent</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill={C.pink}><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                  <span style={{ fontWeight: 600 }}>@thefunkybunchkent</span>
                </div>
              </div>
            </div>

            <div style={{
              background: "#fff", borderRadius: 24,
              border: `2px solid ${C.mint}20`,
              padding: "28px 24px",
            }}>
              <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 16, color: C.ink, marginBottom: 8 }}>
                Where to find us
              </div>
              <div style={{ fontFamily: body, fontSize: 14, color: C.ink + "99", lineHeight: 1.8 }}>
                <strong style={{ color: C.ink }}>Lumina Dance Company</strong><br />
                Eden Business Centre<br />
                South Stour Ave, Ashford<br />
                Kent TN23 7RS<br /><br />
                <span style={{ fontSize: 13 }}>
                  12 parking spaces available outside the studio.
                  Walking distance from Ashford town centre and Ashford International train station.
                </span>
              </div>
            </div>
          </div>

          {/* Contact form */}
          <div style={{ flex: "1 1 340px" }}>
            <div style={{
              background: "#fff", borderRadius: 24,
              border: `2px solid ${C.pink}20`,
              padding: "28px 24px",
            }}>
              <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 16, color: C.ink, marginBottom: 16 }}>
                Send us a message
              </div>
              {sent ? (
                <div style={{
                  textAlign: "center", padding: "32px 16px",
                  animation: "fadeIn 0.4s ease",
                }}>
                  <div style={{ fontFamily: heading, fontSize: 22, fontWeight: 800, color: C.mint, marginBottom: 8 }}>
                    Message sent!
                  </div>
                  <p style={{ fontFamily: body, fontSize: 14, color: C.ink + "88", lineHeight: 1.6 }}>
                    Thanks for getting in touch. We'll get back to you as soon as we can.
                  </p>
                  <button onClick={() => { setSent(false); setName(""); setEmail(""); setMessage(""); }} style={{
                    marginTop: 16, background: "transparent",
                    border: `2px solid ${C.pink}44`, color: C.ink,
                    padding: "10px 24px", borderRadius: 50,
                    fontFamily: heading, fontWeight: 700, fontSize: 13, cursor: "pointer",
                  }}>Send another message</button>
                </div>
              ) : (
                <>
                  <input type="text" placeholder="Your name" value={name}
                    onChange={e => setName(e.target.value)} style={inputStyle} />
                  <input type="email" placeholder="Email address" value={email}
                    onChange={e => setEmail(e.target.value)} style={inputStyle} />
                  <textarea placeholder="Your message..." value={message}
                    onChange={e => setMessage(e.target.value)}
                    style={{ ...inputStyle, minHeight: 120, resize: "vertical" }} />
                  <button
                    onClick={async () => {
                      try {
                        await fetch("/.netlify/functions/contact", {
                          method: "POST",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify({ name, email, message, type: "message" }),
                        });
                        setSent(true);
                      } catch (err) {
                        setSent(true);
                      }
                    }}
                    style={{
                      width: "100%", background: C.pink, color: "#fff",
                      border: "none", padding: "14px", borderRadius: 50,
                      fontFamily: heading, fontWeight: 700, fontSize: 15,
                      cursor: "pointer",
                    }}
                  >Send Message</button>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section style={{ padding: "16px 24px 48px" }}>
        <div style={{ maxWidth: 700, margin: "0 auto" }}>
          <RainbowHeading size={24}>Frequently Asked Questions</RainbowHeading>
          <div style={{ height: 20 }} />
          {faqs.map((faq, i) => (
            <FaqItem
              key={i}
              q={faq.q}
              a={faq.a}
              color={colors[i % colors.length]}
              isOpen={openFaq === i}
              onClick={() => setOpenFaq(openFaq === i ? null : i)}
            />
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
